// constants
import { showSuccessAlert } from "../../constants/alerts";
import { InfluencerActionTypes } from "./constants";

const INIT_STATE = {
  Influencer: [],
  commisionData: [],
  couponData: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface InfluencerData {
  id: string;
  name: string;
  phone: string;
  email: string;
  coupon_code: string;
  expire_in: string;
}

interface InfluencerActionType {
  type:
    | InfluencerActionTypes.API_RESPONSE_SUCCESS
    | InfluencerActionTypes.API_RESPONSE_ERROR
    | InfluencerActionTypes.CREATE_INFLUENCER
    | InfluencerActionTypes.UPDATE_INFLUENCER
    | InfluencerActionTypes.GET_INFLUENCER
    | InfluencerActionTypes.GET_COUPON_REPORTS
    | InfluencerActionTypes.GET_COMMISION_REPORTS
    | InfluencerActionTypes.DELETE_INFLUENCER;
  payload: {
    actionType?: any;
    data?: any;
    error?: string;
    Influencer?: [];
  };
}

interface State {
  Influencer?: InfluencerData[] | [];
  loading?: boolean;
  value?: boolean;
}

const Influencer = (state: State = INIT_STATE, action: InfluencerActionType): any => {
  switch (action.type) {
    case InfluencerActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case InfluencerActionTypes.CREATE_INFLUENCER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case InfluencerActionTypes.GET_INFLUENCER: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            Influencer: action.payload.data,
          };
        }
        case InfluencerActionTypes.GET_COUPON_REPORTS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            couponData: action.payload.data.orderCounts,
          };
        }

        case InfluencerActionTypes.GET_COMMISION_REPORTS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            commisionData: action.payload.data.commisionsData,
          };
        }
        case InfluencerActionTypes.UPDATE_INFLUENCER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case InfluencerActionTypes.DELETE_INFLUENCER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case InfluencerActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case InfluencerActionTypes.CREATE_INFLUENCER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case InfluencerActionTypes.UPDATE_INFLUENCER: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case InfluencerActionTypes.GET_INFLUENCER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case InfluencerActionTypes.GET_COUPON_REPORTS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case InfluencerActionTypes.GET_COMMISION_REPORTS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case InfluencerActionTypes.DELETE_INFLUENCER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case InfluencerActionTypes.CREATE_INFLUENCER:
      return { ...state, loading: true };
    case InfluencerActionTypes.UPDATE_INFLUENCER:
      return { ...state, loading: true };
    case InfluencerActionTypes.GET_INFLUENCER:
      return { ...state, loading: true, initialLoading: true };
    case InfluencerActionTypes.GET_COMMISION_REPORTS:
      return { ...state, loading: true, initialLoading: true };
    case InfluencerActionTypes.GET_COUPON_REPORTS:
      return { ...state, loading: true, initialLoading: true };
    case InfluencerActionTypes.DELETE_INFLUENCER:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default Influencer;
